import Vue from 'vue'
import global_mixin from './global_mixins.js'
import '../css/room_scene_gallery.css'
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
var _ = require('lodash')
import VueGallery from '../components/Gallery.vue'
import { roomSceneGallery } from '../graphql/queries'
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -20,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)

const app = new Vue({
  el: '#app',
  components: {
    Waterfall,
    WaterfallSlot,
    'gallery': VueGallery
  },
  data() {
    return {
      paginationDirection: 'forward',
      tabIndex: 0,
      searchTileAfter: undefined,
      searchTileBefore: undefined,
      seriesFilter: [],
      mosaicFilter: null,
      residentialSceneFilter: null,
      commercialSceneFilter: null,
      trendSceneFilter: null,
      lightboxIndex: null,
      lightboxKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      resultsPage: 1,
      resultsPageMax: 5,
      resultsPageSelect: null,
      firstLimit: 12,
      //      lastLimit: 0,
    }
  },

  apollo: {
    getRoomScenes: {
      query: roomSceneGallery,
      error (error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        } else {
          console.error(error)
        }
      },
      update: data => data.searchScenes,
      variables() {
        return {
          first: this.firstLimit,
          //          last: (this.paginationDirection === 'backwards') ? 12 : undefined,
          //          after: (this.searchTileAfter && this.paginationDirection === 'forward') ? this.searchTileAfter : undefined,
          //          before: (this.searchTileBefore && this.paginationDirection === 'backwards') ? this.searchTileBefore : undefined,
          filter: {
            residential: { "wildcard": this.residentialSceneFilter },
            commercial: { "wildcard": this.commercialSceneFilter },
            mosaics: { "wildcard": this.mosaicFilter },
            seriesId: { "in": this.seriesFilter }
          }
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },
    }
  },
  methods: {
    addSeriesToFilter(id) {
      if (_.includes(this.seriesFilter, id)) {
        this.seriesFilter = _.filter(this.seriesFilter, function(n) {
          return n != id
        })
        //        this.reloadData()
      } else {
        this.seriesFilter.push(id)
        this.seriesFilter = Array.from(new Set(this.seriesFilter))
        //        this.reloadData()
      }
    },
    getTiles(scene) {
      let data = ""
      for (const tiles of scene.node.tiles) {
        data = data + tiles.sku + ", "
      }
      data = data.substring(0, data.length - 2)
      return data
    },
    setFilters(filter) {
      this.isLoading = true
      this.paginationDirection = 'forward'
      this.searchTileAfter = undefined
      this.searchTileBefore = undefined
      this.firstLimit = 12
      this.seriesFilter = []
      if (filter == "All") {
        this.residentialSceneFilter = null
        this.commercialSceneFilter = null
        this.mosaicFilter = null
      } else if (filter == "Mosaics") {
        this.residentialSceneFilter = null
        this.commercialSceneFilter = null
        this.mosaicFilter = "?*"
      } else if (filter == "Residential") {
        this.residentialSceneFilter = "?*"
        this.commercialSceneFilter = null
        this.mosaicFilter = null
      } else if (filter == "Commercial") {
        this.residentialSceneFilter = null
        this.commercialSceneFilter = "?*"
        this.mosaicFilter = null
      }
      this.isLoading = false
    },
    /*    previousPage() {
          this.paginationDirection = 'backwards'
          this.searchTileAfter = undefined
          this.searchTileBefore = this.getRoomScenes.pageInfo.startCursor
          //      this.reloadData()
          this.$scrollTo('.room-scene-gallery-container')
          this.resultsPage--
        },
        nextPage() {
          this.paginationDirection = 'forward'
          this.searchTileAfter = this.getRoomScenes.pageInfo.endCursor
          this.searchTileBefore = undefined
          //      this.reloadData()
          this.$scrollTo('.room-scene-gallery-container')
          this.resultsPage++
        },*/
    reloadData: _.throttle(async function() {
      try {
        this.isLoading = true
        this.searchTileAfter = undefined
        this.searchTileBefore = undefined
        this.residentialSceneFilter = null
        this.commercialSceneFilter = null
        this.mosaicFilter = null
        this.seriesFilter = []
        /*
        let request_data = {
          'action': 'room_scene_search',
          'page': this.resultsPage,
          'mosaics': this.mosaicFilter
        }
        request_data['series'] = this.seriesFilter
        request_data['residentialFilter'] = this.residentialSwitch
        if (typeof this.residentialSceneFilter === 'string') {
          request_data['residentialSceneFilter'] = this.residentialSceneFilter
        }
        if (typeof this.commercialSceneFilter === 'string') {
          request_data['commercialSceneFilter'] = this.commercialSceneFilter
        }
        if (typeof this.trendSceneFilter === 'string') {
          request_data['trendSceneFilter'] = this.trendSceneFilter
        }
        let response = await this.$http.post('/api/public/v1/', request_data)
        */
        this.lightboxKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

        this.isLoading = false
      }
      catch (error) {
        this.isLoading = false
        this.addAlert('There was an error loading room scene data!', 'danger')
      }
    }, 750)
  },
  computed: {
    lightboxContent() {
      let data = []
      if (this.getRoomScenes) {
        for (const element of this.getRoomScenes.edges) {
          data.push({
            image: element.node.largeImage,
            the_description: element.node.lightboxDescription + this.getTiles(element),
            href: element.node.largeImage,
          })
        }
      }
      return data
    },

    roomScenes() {
      let roomScenes = []
      if (this.getRoomScenes) {
        for (const element of this.getRoomScenes.edges) {
          roomScenes.push({
            commercial: element.node.commercial,
            description: element.node.description,
            id: element.node.id,
            lightbox_description: null,
            originalImage: element.node.originalImage,
            residential: element.node.residential,
            series: element.node.series.name,
            seriesURL: element.node.series.url,
            seriesCategory: element.node.series.category,
            sliderImage: element.node.largeImage,
            tiles: this.getTiles(element),
            trend: element.node.trend,
            waterfallImage: element.node.cardImage,
            type: element.node.series.type
          })
        }
      }
      return roomScenes
    },
    /*    
        resultsPage(){
          this.resultsPage = response.data.currentPage
          this.resultsPageMax = response.data.totalPages
          this.resultsPageSelect = this.resultsPage.toString()
        },
        
        firstLimit(){
          this.firstLimit = response.data.firstLimit
        },
    */
    lastLimit() {
      let lastLimit = 0
      if (this.getRoomScenes) {
        lastLimit = this.getRoomScenes.edges.length
      }
      return lastLimit
    },

    totalScenes() {
      let totalScenes = 0
      if (this.getRoomScenes) {
        totalScenes = this.getRoomScenes.edges.length
      }
      return totalScenes
    },

  },

  mounted() {
    if (urlParams.has('tab')) {
      let tab = urlParams.get('tab')
      switch (tab) {
        case 'collections':
          // this.tabIndex = 0
          this.setFilters('All')
          break
        case 'residential':
          this.setFilters('Residential')
          setTimeout(() => {
            this.tabIndex = 1
          }, 100)
          break
        case 'commercial':
          setTimeout(() => {
            this.tabIndex = 2
          }, 100)
          this.setFilters('Commercial')
          break
        case 'mosaics':
          setTimeout(() => {
            this.tabIndex = 3
          }, 100)
          this.setFilters('Mosaics')
          break
      }
    }
  },
  mixins: [global_mixin],
  watch: {
    residentialSwitch: function(newVal, oldVal) {
      /*      if (newVal !== oldVal) {
              this.reloadData()
            }*/
    },
    resultsPageSelect: function(newValue, oldValue) {
      /*      if (newValue != oldValue && oldValue != null) {
              this.resultsPage = parseInt(newValue)
              this.reloadData()
              this.$scrollTo('.room-scene-gallery-container')
            }*/
    },
  }
})



// WEBPACK FOOTER //
// ./core/vue/js/room_scene_gallery.js